var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "accordion" } }, [
      _c(
        "div",
        {
          staticClass: "row align-items-center log w-full",
          attrs: { id: "heading-" + _vm.log.id }
        },
        [
          _c("div", { staticClass: "col-3 circle-line" }, [
            _c("i", { staticClass: "fa fa-circle blue-grey" }),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-column" }, [
              _c("div", [
                _c("p", { staticClass: "mb-0 log-time" }, [
                  _vm._v(_vm._s(_vm.log.created_time))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-9 single-log w-full flex flex-wrap",
              attrs: {
                "data-toggle": "collapse",
                "data-parent": "#accordion",
                "data-target": "#collapse-" + _vm.log.id,
                "aria-controls": "#collapse-" + _vm.log.id
              }
            },
            [
              _c("div", { staticClass: "flex" }, [
                _c("i", { staticClass: "fa fa-check-circle approved-icon" }),
                _vm._v(" "),
                _c("p", { staticClass: "log-description m-b" }, [
                  _vm._v(_vm._s(_vm.log.title))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c(
                  "a",
                  {
                    staticClass: "log-link float-right collapsed",
                    attrs: {
                      href: "",
                      "data-toggle": "collapse",
                      "data-parent": "#accordion",
                      "data-target": "#collapse-" + _vm.log.id,
                      "aria-controls": "#collapse-" + _vm.log.id
                    }
                  },
                  [_vm._m(0), _vm._v(" "), _vm._m(1)]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse collapse-note col-9 flex float-right",
          attrs: {
            id: "collapse-" + _vm.log.id,
            "aria-expanded": "false",
            "aria-labelledby": "heading-" + _vm.log.id,
            "data-parent": "#accordion"
          }
        },
        [
          _c("div", { staticClass: "col-12 single-log note w-full" }, [
            _c("span", [
              _vm._v("Done by: "),
              _c("b", [_vm._v(_vm._s(_vm.log.user.username))])
            ]),
            _vm._v(" "),
            _vm.log.from_value
              ? _c("p", { staticClass: "mt-1 mb-0" }, [
                  _c("b", [_vm._v("Old value:")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" " + _vm._s(_vm.log.from_value))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.log.to_value
              ? _c("p", { staticClass: "m-0 mt-3" }, [
                  _c("b", [_vm._v("New value:")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" " + _vm._s(_vm.log.to_value))
                ])
              : _vm._e()
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "show-collapsed" }, [
      _c("i", { staticClass: "fa fa-chevron-down cloudy-blue" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "show-expanded" }, [
      _c("i", { staticClass: "fa fa-chevron-up cloudy-blue" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e02240c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e02240c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/LogsItem.vue
// module id = null
// module chunks = 